import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) =>
	state.api.network.dns.record.multiCreateAndUpdate;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_RECORD_MULTICREATEANDUPDATE',
	method: 'POST',
	url: '/network/dns/record/multiCreateAndUpdate.json',
});

export { actions, reducer, sagas, selectors };
